import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=1421ca69&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=ts"
export * from "./UserAdd.vue?vue&type=script&lang=ts"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=1421ca69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1421ca69",
  null
  
)

export default component.exports